module.exports = __webpack_public_path__ + "img/banner2.3d465f48.png";